import classNames from "classnames";
import React, { useEffect } from "react";
import Videojs from "../../../components/video-js";
import Heading from "../../../elements/heading";
import IconLink from "../../../elements/icon-link";
import BodyText from "../../../elements/body-text";
import Image from "../../../elements/image";
import PrimaryButton from "../../../elements/primary-button";
import PrimaryLink from "../../../elements/primary-link";

const ImageSlide = ({ index, backgroundColor, image, overline, headingBody, headingTypographyClass, headingType, body, CTA, slideSize, currentPageIndex }) => {
  const getButton = button => {
    if (button.type === "primary-button") {
      return <PrimaryButton {...button.props} />;
    } else if (button.type === "primary-link") {
      return <PrimaryLink {...button.props} />;
    } else {
      // default type
      return <IconLink {...button.props} />;
    }
  };

  let textContainerClasses = classNames("text-container", {
    "full-width": image?.type === undefined
  });

  let imageContainerClasses = classNames("image-container", {
    "full-width": (headingBody.value === "" || headingBody.value === undefined) && (body.value === "" || body.value === undefined) && (overline.value === "" || overline.value === undefined)
  });
  let slideStyle = {
    minWidth: `${slideSize - 60}px`,
    maxWidth: `${slideSize - 60}px`,
    backgroundColor: backgroundColor ? backgroundColor?.fields?.phrase?.value : ""
  };

  return (
    /* Slide controls size and padding */
    <div className={"slide"} key={index} style={slideStyle}>
      <div className="slide-scroll-container">
        <div className={"slide-content grid-story"}>
          <div className={imageContainerClasses}>
            {image.type === "image" && <Image {...image} />}
            {image.type === "video" && <Videojs {...image} forceVideoPause={index !== currentPageIndex + 1} />}
          </div>
          <div className={textContainerClasses}>
            {overline.value !== "" && <span className="overline">{overline.value}</span>}
            {headingBody.value && <Heading type={headingType ? headingType : { fields: { phrase: { value: "h2" } } }} className={"title"} html={headingBody} typographyClass={headingTypographyClass ? headingTypographyClass.value : "type-h2"} />}
            {body && body.value && <BodyText className={"body-text"} tag="div" html={body.value} />}
            {CTA && <div className={"button-container"}>{getButton(CTA)}</div>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImageSlide;
